import apiClient from "./axios";
import { ApiResponse, PaginatedResponse, AuditLog } from "../types";

export interface GetAuditLogsParams {
  adminEmail?: string;
  action?: string;
  targetType?: string;
  fromDate?: string;
  toDate?: string;
  page?: number;
  limit?: number;
}

export const auditLogsApi = {
  getAuditLogs: async (params: GetAuditLogsParams = {}) => {
    const { data } = await apiClient.get<
      ApiResponse<PaginatedResponse<AuditLog>>
    >("/admin/audit-logs", { params });
    return data.data;
  },
};
